export default __webpack_public_path__ + "static/media/tr.6ea32e5d.svg";